'use strict';
// TODO: remove from `core-js@4`
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('patternMatch');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.symbol.pattern-match.js
// module id = 751
// module chunks = 13